import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getCommitteeProofsOptions,
  useDeleteCommitteeProof,
  useUploadOrUpdateCommitteeProof,
} from './model/CommitteeProofModel';

interface CommitteeProofActionProps {
  committeeId: number;
  authors: Author[];
  variant?: 'compact';
}

export function CommitteeProofAction({ committeeId, authors }: CommitteeProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getCommitteeProofsOptions(committeeId));
  const uploadOrUpdateMutation = useUploadOrUpdateCommitteeProof(committeeId);
  const deleteMutation = useDeleteCommitteeProof(committeeId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="committee"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
